import PropTypes from "prop-types";
import { Fragment, memo } from "react";
import Button from "app/pages/.shared/form/Button";
import "./FacebookLogin.scss";
import { FormattedMessage } from "react-intl";

const FacebookLogin = ({ isSignup, isDisabled, onClick, isLoading }) => {
	return (
		<Button
			loading={isLoading}
			onClick={onClick}
			disabled={isDisabled}
			className="button button--facebook"
			data-testid="facebook-login-button"
		>
			{!isDisabled && (
				<Fragment>
					<i className="icon icon--facebook-white" />
					<div>
						{isSignup ? (
							<FormattedMessage id="auth.facebook.signup.button.label" />
						) : (
							<FormattedMessage id="auth.facebook.signin.button.label" />
						)}
					</div>
				</Fragment>
			)}
		</Button>
	);
};

FacebookLogin.propTypes = {
	isSignup: PropTypes.bool,
	onClick: PropTypes.func,
	isLoading: PropTypes.bool,
	isDisabled: PropTypes.bool,
};

export default memo(FacebookLogin);
